import {
  Alert,
  Backdrop,
  Box,
  Button,
  Collapse,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React from "react";
import * as yup from "yup";
import Loader from "../../components/Loader";
import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import { logout } from "../../redux/actions/auth";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { connect, useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Breadcrumbs from "./Breadcrumbs";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { AccountCircle } from "@mui/icons-material";
import { useEffect } from "react";
import moment from "moment";
import Popover from "@mui/material/Popover";
import FireLogo from "../../assets/images/85154-01.png";
import DateRangePickerr from "./Dashboard/DateRangePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import { addDays } from "date-fns";
import ForwardIcon from "@mui/icons-material/Forward";
import ModeStandbyIcon from "@mui/icons-material/ModeStandby";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { common_axios } from "../../App";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useRef } from "react";
import { setButttonStatus } from "../../redux/features/TableSlice";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useFormik } from "formik";
import Swal from "sweetalert2";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function Navbar(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openn, setOpenn] = useState(false);
  const [navopen, setnavopen] = useState(false);
  const [truefalse, settruefalse] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEll, setAnchorEll] = React.useState(null);
  const [showPassword3, setShowPassword3] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  var [date, setDate] = useState(new Date());
  const [shyamCode, setshyamCode] = useState(undefined);
  const [ee1, setee1] = useState({
    dateform: null,
  });
  const [datee, setdatee] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const approvvalEnable1 = useRef(null);

  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries
  );
  const handleClick = async (e) => {
    setAnchorEl(null);
    await approvvalEnable1?.current.click();
    // await props.logout();
    // history.entries = [];
    // history.index = -1;
    // history.replace("/");
  };

  const EnableDisabled = async (e) => {
    // await approvvalEnable?.current.click();
    await props.logout();
    history.entries = [];
    history.index = -1;
    history.replace("/");
  };

  const dispatch = useDispatch();

  const passExpDays = JSON.parse(localStorage?.getItem("items"));

  const tabSwitch = useRef(null);

  const tabModal = () => {
    tabSwitch.current.click();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const detaiilsOfUser = JSON.parse(
    localStorage.getItem("usermodal")
  )?.bankDetails;
  const detailsEntity = JSON.parse(localStorage.getItem("usermodal"));

  // const navopen = () => {
  //   document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
  //   // settruefalse(true)
  // };

  if (
    document?.getElementById("main-section-sidebar")?.classList != undefined
  ) {
    if (navopen == false) {
      document.body.className = "g-sidenav-show bg-gray-200  p-0";
      const section = document?.getElementById("main-section-sidebar");
      section.classList.value = "sec_1";
    } else {
      document.body.className =
        "g-sidenav-show bg-gray-200 p-0 g-sidenav-pinned";
      const section = document?.getElementById("main-section-sidebar");
      section.classList.value = "sec_2";
    }
  }

  var stat = moment().format("MMMM Do YYYY, h:mm:ss a");

  const location = useLocation();

  const loki = location.pathname;
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });
  const markclose = useRef(null);

  const markColseModal = async () => {
    await markclose.current.click();
  };
  const usermodal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;
  const markAttendence = async () => {
    try {
      setOpen(false);
      const res = await common_axios.post(`/attendance/markAttendance`, {
        userId: localStorage.getItem("UserId"),
        status: 1,
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        numberOfDays: 1,
        userGroup: usermodal,
        userName: localStorage.getItem("usernamedisplayed"),
      });
      if (res.data.statusDescriptions.statusCode == 200) {
        dispatch(setButttonStatus());
        setOpen(false);
        markColseModal();
        // markAttendacne();

        // await setLocation({
        //   ...location,
        //   showlastdiv: true,
        // });

        await setTimeout(async () => {
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      } else {
        setOpen(false);
        await setTimeout(async () => {
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await setTimeout(async () => {
        // await toast.error("Something went wrong !! Please check your network", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });
  const mark = useRef(null);

  // const markAttendacne = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`/attendance/viewAttendance`, {
  //       userId: localStorage.getItem("UserId"),
  //       year: datee.year,
  //       month: datee.month,
  //     });

  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       setOpen(false);

  //       // for (let index = 0; index < res.data.attendanceEntity.length; index++) {
  //       //   const element = res.data.attendanceEntity[index];

  //       //   var dates = moment(res.data.attendanceEntity[index].date).format(
  //       //     "DD-MM-YYYY"
  //       //   );

  //       //   var now = moment(new Date()).format("DD-MM-YYYY");

  //       //   console.log(dates, now);

  //       //   // datess.push(
  //       //   //   moment(element.date).format("DD-MM-YYYY"),
  //       //   //   element.status
  //       //   // );
  //       // }
  //       res.data.attendanceEntity.map((e) => {
  //         // let datefom = moment(e.date).format("DD-MM-YYYY");

  //         setee1({
  //           ...e,
  //           dateform: moment(e.date).format("DD-MM-YYYY"),
  //         });
  //       });

  //       // x.toLocaleDateString()
  //     } else {
  //       setOpen(false);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: res.data.statusDescriptions.statusDescription,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something Went Wrong !! Please check your network ",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  // };
  // useEffect(() => {
  //   markAttendacne();
  // }, []);

  useEffect(() => {
    let newform = moment(new Date()).format("DD-MM-YYYY");

    if (ee1.dateform == newform) {
      setshyamCode(ee1);
    }
  }, [ee1.dateform]);

  useEffect(() => {
    if (
      props?.location?.pathname == "/" ||
      props?.location?.pathname == "/dashboard" ||
      props?.location?.pathname == "/Dashboard"
    ) {
      settruefalse(true);
    } else {
      settruefalse(false);
    }
  }, [props?.location?.pathname]);

  // console.log(
  //   moment(new Date()).add("days", 3),
  //   moment(new Date()).add("days", 3)._d,
  //   moment(passExpDays?.passwordExpireDate._d)
  // );

  const viewProfile = useRef(null);
  const viewProfileModal = () => {
    viewProfile.current.click();
  };

  const markModal = async () => {
    await setshyamCode(shyamCode);
    await mark.current.click();
  };

  var details = JSON.parse(localStorage.getItem("Sidebaritems"))?.name;

  const modalSelect = useSelector((state) => state.modalSlice.button);

  const approvvall = useRef(null);
  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);
  const validationSchema = yup.object({
    newPassword: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(`api/auth/v1/changePassword`, {
          newPassword: values.newPassword,
          reTypePassword: values.confirmPassword,
          userId: localStorage.getItem("UserId"),
        });

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await setTimeout(async () => {
            await toast.success(res.data.statusDescriptions.statusDescription, {
              theme: "colored",
            });
          }, 100);
          await formik.handleReset();

          await markAttendacneref?.current?.click();
        } else {
          setOpen(false);
          await setTimeout(async () => {
            await toast.error(res.data.statusDescription.description, {
              theme: "colored",
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        console.log(error);

        await setTimeout(async () => {
          await toast.error(
            "Something went wrong!! Please check your network",
            {
              theme: "colored",
            }
          );
        }, 100);
      }
    },
  });

  const markAttendacneref = useRef(null);

  return (
    <>
      <>
        {props?.location?.pathname == "/" ||
        props?.location?.pathname == "/dashboard/MarkAttendance" ? (
          <>
            <button
              ref={mark}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop9"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop9"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" id="markmodal">
                <div className="modal-content" style={{ top: "10rem" }}>
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Mark Attendance
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <div className="row">
                        {shyamCode?.status == 1 ? (
                          <div class="text-center">
                            <h6>Already Marked Present For Today</h6>
                          </div>
                        ) : shyamCode?.status == 2 ? (
                          <div class="text-center">
                            <h6>Already Marked Casual-Leave For Today</h6>
                          </div>
                        ) : shyamCode?.status == 0 ? (
                          <div class="text-center">
                            <h6>Already Marked Absent For Today</h6>
                          </div>
                        ) : shyamCode?.status == 3 ? (
                          <>
                            <div class="text-center">
                              <h5>Already Marked Optional-off For Today</h5>
                            </div>
                          </>
                        ) : (
                          <h6>
                            {localStorage.getItem("usernamedisplayed")}{" "}
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                            {stat}
                          </h6>
                        )}
                      </div>
                    </div>
                    <hr className="mb-2" />
                  </ThemeProvider>
                  {/* <div className="modal-footer"> */}
                  <div className="px-2 pb-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <Button
                        ref={markclose}
                        data-bs-dismiss="modal"
                        sx={{ marginLeft: "10px", background: "#4C4234" }}
                        type="reset"
                        variant="contained"
                        endIcon={<CancelIcon />}
                      >
                        Close
                      </Button>
                      {shyamCode?.status == null || undefined ? (
                        <Button
                          type="button"
                          variant="contained"
                          sx={{ background: "#F96B02", color: "white" }}
                          endIcon={<SendIcon />}
                          onClick={() => {
                            markAttendence();
                          }}
                        >
                          Mark
                        </Button>
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </>
        ) : null}
      </>

      <button
        ref={viewProfile}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop10"
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal fade"
        id="staticBackdrop10"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Profile Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <ThemeProvider theme={theme}>
              <div className="modal-body">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      ref={tabSwitch}
                      // class="nav-link active"
                      class="nav-link active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      type="button"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                      // onClick={() => {
                      //   settabToggle(false);
                      // }}
                      // tabToggle={false}
                    >
                      Basic Information
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link ms-2"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Bank Details
                    </button>
                  </li>
                </ul>
                <div class="tab-content mt-3" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Username:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.username
                          }
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Name:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.firstName
                          }{" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.lastName
                          }
                        </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Payroll-Id:
                        </label>
                        <span className=""> {detailsEntity?.payrollId}</span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Role:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("Sidebaritems"))
                              ?.name
                          }
                        </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Organisation:
                        </label>
                        <span className=""> {detailsEntity?.organization}</span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Location:
                        </label>
                        <span className=""> {detailsEntity?.location}</span>
                      </div>
                    </div>
                    {/* <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          OPS Head:
                        </label>
                        <span className=""> Amanpreet Singh</span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          CSM:
                        </label>
                        <span className=""> Prince Chaudhary</span>
                      </div>
                    </div> */}
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Contact No.:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.mobileNo
                          }
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          E-Mail:
                        </label>
                        <span className="">
                          {" "}
                          {JSON.parse(localStorage.getItem("usermodal"))?.email}
                        </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Aadhar Number:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.aadharCard
                          }
                        </span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Address:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.address
                          }
                        </span>
                      </div>
                      {/* <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          E-Mail:
                        </label>
                        <span className="">
                          {" "}
                          {JSON.parse(localStorage.getItem("usermodal"))?.email}
                        </span>
                      </div> */}
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          UAN No.:
                        </label>
                        <span className="">
                          {" "}
                          {
                            JSON.parse(localStorage.getItem("usermodal"))
                              ?.uanNumber
                          }
                        </span>
                      </div>

                      {/* <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          E-Mail:
                        </label>
                        <span className="">
                          {" "}
                          {JSON.parse(localStorage.getItem("usermodal"))?.email}
                        </span>
                      </div> */}
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Bank Name:
                        </label>
                        <span className=""> {detaiilsOfUser?.[0]?.bank}</span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Acc. No:
                        </label>
                        <span className="">
                          {" "}
                          {detaiilsOfUser?.[0]?.accountNumber}
                        </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          Bank Branch:
                        </label>
                        <span className=""> {detaiilsOfUser?.[0]?.branch}</span>
                      </div>
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          IFSC Code:
                        </label>
                        <span className="">
                          {" "}
                          {detaiilsOfUser?.[0]?.ifscCode}
                        </span>
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label
                          for="exampleInputEmail1"
                          className="form-label fw-bolder"
                          style={{ fontSize: "13px" }}
                        >
                          PAN No.:
                        </label>
                        <span className="">
                          {" "}
                          {detaiilsOfUser?.[0]?.panNumber}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="modal-footer">
                    <button
                      // ref={modelButtonRejectClose}
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi();
                      }}
                    >
                      Approve User
                    </button>
                  </div> */}
              </div>
            </ThemeProvider>
            <div className="modal-footer">
              <Button
                data-bs-dismiss="modal"
                type="button"
                variant="contained"
                sx={{ background: "#F96B02", color: "white" }}
                endIcon={<CancelIcon />}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
      <button
        ref={approvvall}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop999"
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal mark fade"
        id="staticBackdrop999"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Change Password?
                </h5>
                <button
                  ref={markAttendacneref}
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    formik.handleReset();
                  }}
                ></button>
              </div>

              <ThemeProvider theme={theme}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <TextField
                        required
                        className="w-100"
                        label="New Password"
                        color="primary"
                        size="small"
                        type={showPassword2 ? "text" : "password"}
                        name="newPassword"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword2}
                              >
                                {showPassword2 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.newPassword &&
                          Boolean(formik.errors.newPassword)
                        }
                        helperText={
                          formik.touched.newPassword &&
                          formik.errors.newPassword
                        }
                      />
                    </div>
                    <div className="col-md-6 ">
                      <TextField
                        required
                        className="w-100"
                        label="Confirm Password"
                        color="primary"
                        size="small"
                        type={showPassword3 ? "text" : "password"}
                        name="confirmPassword"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword3}
                                onMouseDown={handleMouseDownPassword3}
                              >
                                {showPassword3 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.confirmPassword &&
                          Boolean(formik.errors.confirmPassword)
                        }
                        helperText={
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                        }
                      />
                    </div>
                  </div>
                </div>
              </ThemeProvider>
              <div className="modal-footer justify-content-between text-end">
                <Button
                  data-bs-dismiss="modal"
                  sx={{ marginLeft: "10px", background: "#4C4234" }}
                  variant="contained"
                  endIcon={<CancelIcon />}
                  type="submit"
                  className="m-0"
                  onClick={() => {
                    formik.handleReset();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ marginLeft: "10px", background: "#F96902" }}
                  variant="contained"
                  endIcon={<CheckCircleIcon />}
                  type="submit"
                  className="m-0"
                >
                  Ok
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* modal of enable disable */}

      <button
        ref={approvvalEnable1}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop9122"
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal mark fade"
        id="staticBackdrop9122"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {/* Status */}
              </h5>
              <button
                // ref={markAttendacneref}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={() => {
                //   setstateofButtons({
                //     approval: false,
                //     reject: false,
                //   });
                // }}
              ></button>
            </div>
            <ThemeProvider theme={theme}>
              <div className="modal-body">
                <h5> Are you sure to signout ?</h5>
              </div>
            </ThemeProvider>
            <div className="modal-footer d-flex justify-content-between align-items-center">
              <Button
                data-bs-dismiss="modal"
                sx={{ marginLeft: "10px", background: "#4C4234" }}
                variant="contained"
                // endIcon={<CancelIcon />}
                // onClick={() => {
                //   setstateofButtons({
                //     approval: false,
                //     reject: false,
                //   });
                // }}
              >
                No
              </Button>
              <Button
                data-bs-dismiss="modal"
                sx={{ marginLeft: "10px", background: "#F96902" }}
                variant="contained"
                // endIcon={<CheckCircleIcon />}
                onClick={() => {
                  EnableDisabled();
                }}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* end of the modal */}

      <header>
        <header class="header_1 p_fixed py-2">
          <div class="container-fluid">
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={open}
              // onClick={handleClose}
            >
              <Loader />
            </Backdrop>
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={openn}
            >
              <Loader />
            </Backdrop>
            <div class="d-flex justify-content-between align-items-center">
              <h6 className="text-white h4_ms_5">
                {moment(new Date(), "MMM-DD-YYYY").format("dddd")},
                {moment(new Date(), "MMM-DD-YYYY").format("DD-MMM-YYYY")}
              </h6>

              <div
                class="d-flex text-white justify-content-between align-items-center"
                id="mark_2"
              >
                {/* {props?.location?.pathname == "/" ||
                props?.location?.pathname == "/dashboard/MarkAttendance" ? (
                  <Button
                    className="m-0"
                    id="modalbuuton"
                    //   disabled={buttonDisable}
                    variant="contained"
                    endIcon={<ModeStandbyIcon />}
                    sx={{
                      background: "#4C4234",
                      marginRight: "10px",
                      cursor: "pointer",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      markModal();
                      markAttendacne();
                    }}
                  >
                    Mark in
                  </Button>
                ) : null} */}
                {/* <Button>
                <ModeStandbyIcon
                  sx={{
                    color: "#4C4234",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                />
              </Button> */}
                <span
                  class="d-md-block d-none text-capitalize fw-bold mx-3"
                  id="user_Name"
                >
                  {" "}
                  Welcome [{localStorage.getItem("usernamedisplayed")}]
                </span>

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  className="mx-1"
                  style={{ color: "#ffff" }}
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  // // keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/* <Link to="/dashboard/profile"> */}
                  {/* <MenuItem
                    onClick={() => {
                      viewProfileModal();
                      setAnchorEl(null);
                      tabModal();
                    }}
                  >
                    View Profile
                  </MenuItem> */}
                  {/* </Link> */}
                  {/* <MenuItem
                    onClick={() => {
                      approvvall?.current?.click();
                      setAnchorEl(null);
                    }}
                  >
                    Change Password
                  </MenuItem> */}
                  <MenuItem onClick={handleClick}>Sign Out</MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </header>
        <header class="header_1 p_static d-md-none d-block py-2">
          <div class="container-fluid">
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={open}
              // onClick={handleClose}
            >
              <Loader />
            </Backdrop>
            <Backdrop
              sx={{
                transform: "translateZ(0)",
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={openn}
            >
              <Loader />
            </Backdrop>
            <div class="d-flex justify-content-between align-items-center">
              <h6 className="text-white h4_ms_5">
                {moment(new Date(), "MMM-DD-YYYY").format("dddd")},
                {moment(new Date(), "MMM-DD-YYYY").format("DD-MMM-YYYY")}
              </h6>

              <div class="d-flex text-white justify-content-between align-items-center">
                {/* {props?.location?.pathname == "/" ||
                props?.location?.pathname == "/dashboard/MarkAttendance" ? (
                  <Button
                    id="modalbuuton"
                    //   disabled={buttonDisable}
                    variant="contained"
                    endIcon={<ModeStandbyIcon />}
                    sx={{
                      background: "#4C4234",
                      marginRight: "10px",
                      cursor: "pointer",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      markModal();
                      markAttendacne();
                    }}
                  >
                    Mark in
                  </Button>
                ) : null} */}
                {/* <Button>
                <ModeStandbyIcon
                  sx={{
                    color: "#4C4234",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                />
              </Button> */}
                <span
                  class="d-md-block d-none text-capitalize fw-bold"
                  id="user_Name"
                >
                  {" "}
                  Welcome [{localStorage.getItem("usernamedisplayed")}]
                </span>

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  className="mx-1"
                  style={{ color: "#ffff" }}
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                  // // keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {/* <Link to="/dashboard/profile"> */}
                  {/* <MenuItem
                    onClick={() => {
                      viewProfileModal();
                      setAnchorEl(null);
                      tabModal();
                    }}
                  >
                    View Profile
                  </MenuItem> */}
                  {/* </Link> */}
                  {/* <MenuItem
                    onClick={() => {
                      approvvall?.current?.click();
                      setAnchorEl(null);
                    }}
                  >
                    Change Password
                  </MenuItem> */}
                  <MenuItem onClick={handleClick}>Sign Out</MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </header>
      </header>

      <nav
        class="navbar navbar-main navbar-expand-lg px-0 shadow-none border-radius-xl mt-2"
        id="navbarBlur"
        navbar-scroll="true"
      >
        <div class="container-fluid">
          <Breadcrumbs />
          <div>
            {props?.pathname?.location == "/dashboard/EmployeeRecord" ? (
              <>
                {selectedTime.start ==
                moment(new Date()).format("DD-MM-YYYY") ? (
                  <span
                    className="d-sm-inline ms_2 start_date_time_css"
                    style={{ backgroundColor: "#3c8dbc", color: "white" }}
                  >
                    Today
                  </span>
                ) : selectedTime.start ==
                  moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
                  <span
                    style={{ backgroundColor: "#3c8dbc", color: "white" }}
                    className="d-sm-inline ms_2 start_date_time_css"
                  >
                    Yesterday
                  </span>
                ) : (
                  <>
                    <span
                      style={{ backgroundColor: "#3c8dbc", color: "white" }}
                      className="d-sm-inline ms_2 start_date_time_css"
                    >
                      {selectedTime.start}
                    </span>
                    <ForwardIcon />
                    <span
                      style={{ backgroundColor: "#3c8dbc", color: "white" }}
                      className="d-sm-inline mx_2 start_date_time_css"
                    >
                      {selectedTime.end}
                    </span>
                  </>
                )}
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                  // className="btn bg-gradient-primary "
                  aria-describedby={
                    Boolean(anchorEll) ? "simple-popover" : undefined
                  }
                  onClick={(event) => {
                    setAnchorEll(event.currentTarget);
                  }}
                >
                  <CalendarMonthIcon />
                </IconButton>

                <Popover
                  id={Boolean(anchorEll) ? "simple-popover" : undefined}
                  open={Boolean(anchorEll)}
                  anchorEl={anchorEll}
                  onClose={() => {
                    setAnchorEll(null);
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <DateRangePickerr />
                </Popover>
              </>
            ) : null}
          </div>
        </div>
      </nav>
    </>
  );
}

const mapStateToProps = (state) => ({
  username: state.authReducer.username,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout(localStorage.getItem("Username"))),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
